import { useTranslation } from 'react-i18next';
import EPageHeader from '@/components/everridge/EPageHeader';
import AccountGeneral from '@/features/account/components/AccountGeneral';
import AccountCredentials from '@/features/account/components/AccountCredentials';
import AccountSecurity from '@/features/account/components/AccountSecurity';
import { useProfileApi } from '@/features/account/hooks/useProfileApi.ts';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import { useEffect } from 'react';

const AccountPage = () => {
	const { t } = useTranslation();
	const { profile } = useProfileApi();
	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

	useEffect(() => {
		if (profile?.avatarUrl) {
			profile.avatarUrl = `${profile.avatarUrl}?t=${Date.now()}`;
		}
	});

	return (
		<section className={'flex-1 flex flex-col gap-6'}>
			<EPageHeader
				title={t('main.account.title')}
				addBackButton={true}
			/>
			<AccountGeneral
				profile={profile}
				isMobile={isMobile}
			/>
			<AccountCredentials
				profile={profile}
				isMobile={isMobile}
			/>
			<AccountSecurity
				profile={profile}
				isMobile={isMobile}
			/>
		</section>
	);
};

export default AccountPage;
